// extracted by mini-css-extract-plugin
module.exports = {"title":"Overview-module__title___ztHTC","aboveCard":"Overview-module__aboveCard___3lp_o","snippet":"Overview-module__snippet___1wLy_","link":"Overview-module__link___2hwss"};